import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const ErrorMessage = styled.div`
  ${TypographyV2.s1}
  margin-top: 10px;
  color: ${ColorV2.NegativeRed};
`;
